(function ($, Drupal, drupalSettings, once) {

  'use strict';

  Drupal.behaviors.weaver_alerts = {

    checkAlert: function(alert, duration) {
      // check if alert should be hidden
      let now = new Date();
      let storageName = this.getAlertStorageName(alert.id);
      let expiration = window.localStorage.getItem(storageName);

      if (now < expiration) {
        // remove the alert that shouldn't be shown
        alert.remove();
      } else {
        // remove localStorage value if past expiry time
        window.localStorage.removeItem(this.getAlertStorageName(alert.id));
      }
    },

    getAlertStorageName: function(id) {
      return id + '_expiration';
    },

    hideAlert: function(alert, duration) {
      $(alert).on('hidden.bs.collapse', () => {
        this.setAlertHiddenDuration(alert, duration);
      });
    },

    setAlertHiddenDuration: function(alert, duration) {
      // set the expiry date to {duration} minutes from now
      let datetime = new Date();
      let expirationTimestamp = datetime.setMinutes(datetime.getMinutes() + 30);
      window.localStorage.setItem(this.getAlertStorageName(alert.id), expirationTimestamp);
    },

    attach: function (context, settings) {

      // ensures javascript runs only once per page load and not with every ajax call
      $(once('weaver_alerts', 'body', context)).each(function () {

        const weaver_alerts = Drupal.behaviors.weaver_alerts;
        const duration = drupalSettings.weaver_alerts.alert_hidden_duration;
        const alertsContainers = document.querySelectorAll('[data-ajax="alerts"]');

        if (alertsContainers.length > 0) {

          alertsContainers.forEach((alertContainer) => {

            $.ajax({
              type: "POST",
              url: Drupal.url('nvcl/ajax/load-content/alerts'),
              dataType: 'json',
              success: function (result) {
                if (alert == null) {
                  return;
                }

                alertContainer.innerHTML = result.contents;

                let alerts = alertContainer.querySelectorAll('.weaver-alert');

                if (alerts.length > 0) {
                  alerts.forEach((alert) => {
                    weaver_alerts.hideAlert(alert, duration);
                    weaver_alerts.checkAlert(alert, duration);
                  });
                }
              },
              error: function (status) {
                // TODO error handling
                console.log(status);
              }
            });

          });
        }

      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
